import { LogClient_ConsoleProxy } from '@nu-art/logger';
import { ApiDef_AdvisorConsoleProxy } from './api-def.js';
import { apiWithBody, Thunder } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorApplicationName } from '@app/advisor-shared';
class LogClient_AdvisorConsoleProxy_Class extends LogClient_ConsoleProxy {
    appName = AdvisorApplicationName;
    sendLogsToEndpoint = async (logs) => {
        const thunderInstance = Thunder.getInstance();
        // never report of local logs to coralogix
        if (thunderInstance.getEnvironment().toLowerCase() === 'local')
            return;
        const apiDef = ApiDef_AdvisorConsoleProxy.vv1.sendLogs;
        // set the end point dynamically with the value from the config
        apiDef.baseUrl = thunderInstance.getConfig().uiLogsEndpoint;
        // call the api
        return apiWithBody(apiDef)({ logs, systemName: this.appName }).executeSync();
    };
}
export const LogClient_AdvisorConsoleProxy = new LogClient_AdvisorConsoleProxy_Class();
//# sourceMappingURL=LogClient_AdvisorConsoleProxy.js.map